import { useEffect, useState } from 'react'
import { searchPlaces } from './geocode.js'

/**
 * Debounced place search. status: 'idle' (no query) | 'short' (< 3 chars) |
 * 'loading' | 'done' | 'error'. Stale requests are aborted, so a slow answer to
 * "Anděl" can never overwrite the results for "Andělská".
 */
export function useGeocoder(query, { delay = 300 } = {}) {
  const [state, setState] = useState({ status: 'idle', results: [] })
  useEffect(() => {
    const q = query.trim()
    if (!q) {
      setState({ status: 'idle', results: [] })
      return
    }
    if (q.length < 3) {
      setState({ status: 'short', results: [] })
      return
    }
    const ctl = new AbortController()
    setState((s) => ({ status: 'loading', results: s.results }))
    const timer = setTimeout(() => {
      searchPlaces(q, { signal: ctl.signal })
        .then((results) => setState({ status: 'done', results }))
        .catch((err) => {
          if (err.name !== 'AbortError') setState({ status: 'error', results: [] })
        })
    }, delay)
    return () => {
      clearTimeout(timer)
      ctl.abort()
    }
  }, [query, delay])
  return state
}
